





































































































































































import { Component, Prop, Emit, Vue } from "vue-property-decorator";
import { post, get } from "@/utils/ajax";
@Component
export default class Goods extends Vue {
  @Prop() private goodsInfo!: any;
  @Prop() private setGoods!: (goods: any) => void;
  @Prop() private closeDialog!: () => void;
  goodsList: any;

  public data() {
    return {
      value: "指定商品",
      goodsList: [],
      chooseList: [],
      isLoading: false,

      title: "",
      sku_id: "",
      total: 0,
      list: [],
      page: 1,
    };
  }
  public getNameClass({ row, rowIndex }: any) {
    if (rowIndex === 0 && this.goodsList.length) {
      return "opera";
    } else {
      return "noopera";
    }
  }

  public mounted() {
    this.$data.goodsList = JSON.parse(JSON.stringify(this.goodsInfo.goods));
    this.queryList(1);
    // this.$data.goodsList = this.goodsInfo.goods.concat();
  }

  // 获取商品
  public async queryList(num: any) {
    this.$data.isLoading = true;
    this.$data.page = num || 1;
    try {
      const params: any = {
        page: this.$data.page,
        page_size: 5,
        title: this.$data.title,
        sku_id: this.$data.sku_id,
      };
      const data = await get("/admin/basic/jd-goods/onsale-list", params);

      this.$data.list = data.list;
      this.$data.total = data.total;
      this.$data.list.map((item: { isactive: any; sku_id: any }) => {
        item.isactive = false;
        this.$data.goodsList.forEach((good: { sku_id: any }) => {
          if (item.sku_id == good.sku_id) {
            item.isactive = true;
            return;
          }
        });
        return item;
      });
    } catch (error) {
      this.$data.list = [];
      this.$data.total = 0;
      this.$data.page = 1;
      (this as any).$message.error(error.msg || error.message || error);
    }
    this.$data.isLoading = false;
  }

  // 同步商品
  public syncGoods() {
    // if (this.$store.state.userInfo.shop_mold == 1) {
    //   this.$confirm("因业务需求，该功能暂停使用，请联系客服。", {
    //     title: "商品同步提醒",
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   });
    //   return;
    // }
    this.$confirm(
      "同步商品可能会是一个长耗时的操作，再同步过程中尽量不要进行任何操作?",
      {
        title: "商品同步提醒",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    )
      .then(async () => {
        this.$data.isLoading = true;
        // 发送同步请求
        await this.syncGoodsPost();
        await this.queryList(1);
      })
      .catch((error) => {
        if (error === "sync_failed") {
          this.$message.error("同步失败");
        } else {
          this.$message.error(error);
        }
      });
    this.$data.isLoading = false;
  }
  public async syncGoodsPost() {
    try {
      const syncGoodsApi = "/admin/basic/jd/sync-items";
      const syncGoodsKEYApi = "/admin/basic/jd/goods/get-sync-key";
      const { key } = await get(syncGoodsKEYApi, { activity_id: 14 });
      const res = await this.loop(key);
      if(res) {
        this.$message.success("同步成功");
      } else {
         this.$message.error("同步失败");
      }
    } catch (error) {
         this.$message.error("同步异常");
    }
  }
  // 2000146-2694f235-c9b6-4f33-81cb-dbf8c9f0df89
  async loop(key: any) {
    const syncGoodsRESULTApi = "/admin/basic/jd/goods/query-sync-result";
    const result = await get(syncGoodsRESULTApi, { activity_id: 14, key });
    if (result.status === "syncing") {
      await this.loop(key);
    } else if (result.status === "sync_success") {
      return true
    } else if (result.status === "sync_failed") {
      return false
    }

  }
  // 添加商品
  public pushItem(item: any) {
    item.isactive = true;
    this.$data.goodsList.push(item);
  }
  // 取消商品
  public cancel(item: any) {
    this.$data.goodsList.map((good: any, index: any) => {
      if (good.sku_id == item.sku_id) {
        (item.isactive = false), this.$data.goodsList.splice(index, 1);
      }
    });
    let newList = new Array();
    newList = [];
    this.$data.list.forEach((good: { sku_id: any; isactive: boolean }) => {
      if (good.sku_id == item.sku_id) {
        good.isactive = false;
      }
      newList.push(good);
    });
    this.$data.list = newList;
  }

  // 确定
  public confirmGoods() {
    this.setGoods(this.$data.goodsList);
    this.closeGoods();
  }
  // 取消
  public async closeGoods() {
    this.$data.goodsList = [];
    this.closeDialog();
  }
  public async headerClick(column: any, event: any) {
    if (this.$data.goodsList.length == 0) {
      return false;
    }
    if (column.label == "全部清空") {
      this.$data.goodsList = [];
      this.goodsInfo.goods = [];
      let newList = new Array();
      newList = [];
      this.$data.list.map((good: { sku_id: any; isactive: boolean }) => {
        good.isactive = false;
        newList.push(good);
        return good;
      });
      this.$data.list = newList;
    }
  }
}
